<template>
  <div>
    <h1>
      <b>Clientes</b>
    </h1>
    <div class="form-group pull-left">
      <router-link to="/clientes/crear">
        <button type="button" class="btn btn-success md-elevation-24">
          <i class="fa fa-plus-circle"></i> Crear cliente
        </button>
      </router-link>
    </div>
    <div>
      <div
        class="form-group pull-right"
        style="padding-right: 10px; padding-left: 10px; text-align: right;"
      >
        <div class="row">
          <div
            class="col-md-12"
            style="display: flex;
                align-items: center;
                justify-content: center;"
          >
            <div>
              <a-input-search
                size="large"
                v-model="filter"
                v-on:keyup.enter="() => onKeyPress()"
                placeholder="Buscar cliente"
                @search="() => sendRequestClientes()"
              />
            </div>
            <div style="padding: 5px;">
              <a-button
                shape="circle"
                :loading="procesando"
                type="danger"
                icon="close"
                @click="() => limpiarFiltros()"
              ></a-button>
            </div>
          </div>
        </div>
        <a-pagination
          style="padding-top: 10px"
          @change="onChange"
          :current="page"
          :total="pagination.totalPage"
        />
      </div>
      <span class="counter pull-right"></span>
      <div class="row">
        <div id="table" class="col-xs-12 table-responsive">
          <Load v-if="procesando" text="Buscando información"></Load>
          <md-table
            v-else
            md-elevation-24
            v-model="row"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="() => customSort()"
            md-card
          >
            <md-table-empty-state
              md-label="No se encontrarón datos"
            ></md-table-empty-state>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell
                translate="no"
                md-label="ID"
                md-sort-by="id"
                md-numeric
              >
                <router-link
                  :to="{
                    name: 'editar-cliente',
                    params: { clienteId: item.id },
                  }"
                >
                  <a href="#">{{ item.id }}</a>
                </router-link>
              </md-table-cell>
              <md-table-cell
                translate="no"
                md-label="NOMBRES"
                md-sort-by="nombre"
              >
                <router-link
                  :to="{
                    name: 'crear-orden-servicio',
                    params: { clienteId: item },
                  }"
                >
                  <a href="#">{{
                    `${item.nombre} ${
                      item.apellidos ? item.apellidos : ''
                    }`
                  }}</a>
                </router-link>
              </md-table-cell>
              <md-table-cell
                translate="no"
                md-label="CÉDULA"
                md-sort-by="cedula"
                >{{ `${item.cedula}` }}</md-table-cell
              >
              <md-table-cell
                translate="no"
                md-label="CELULAR"
                md-sort-by="celular"
                >{{
                  `${item.celular ? item.celular : 'No registra'}`
                }}</md-table-cell
              >
              <md-table-cell
                translate="no"
                md-label="TELËFONO"
                md-sort-by="telefono"
                >{{
                  `${item.telefono ? item.telefono : 'No registra'}`
                }}</md-table-cell
              >
              <md-table-cell translate="no" md-label="OPCIONES">
                <a-dropdown>
                  <a-menu slot="overlay" @click="handleMenuClick">
                    <a-menu-item key="1">
                      <router-link
                        :to="{
                          name: 'editar-cliente',
                          params: { clienteId: item.id },
                        }"
                      >
                        <a href="#">Ver / Editar</a>
                      </router-link>
                    </a-menu-item>
                    <a-menu-item key="1">
                      <router-link
                        :to="{
                          name: 'crear-orden-servicio',
                          params: { clienteId: item },
                        }"
                      >
                        <a href="#">Crear OS</a>
                      </router-link>
                    </a-menu-item>
                    <a-menu-item key="2">
                      <a @click="eliminar(item.id)" href="#"
                        >Eliminar</a
                      >
                    </a-menu-item>
                  </a-menu>
                  <a-button type="primary" style="margin-left: 8px">
                    Opciones
                    <a-icon type="down" />
                  </a-button>
                </a-dropdown>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 form-inline">
          <!-- <a-pagination  @change="onChange" :current="page" :total="pagination.totalPage" /> -->
        </div>
      </div>
    </div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :on-cancel="onCancel"
      loader="dots"
      color="#164880"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<script>
import ServiceApi from '../../ServiceApi';
import Loading from 'vue-loading-overlay';
import Load from '../Helpers/Loading';
import { mapState } from 'vuex';
export default {
  name: 'clientes',
  components: {
    Loading,
    Load,
  },
  computed: mapState(['topicSocket', 'usuarioId', 'rol']),
  data() {
    return {
      filter: '',
      loading: true,
      procesando: false,
      currentSort: 'id',
      currentSortOrder: 'desc',
      pagination: {
        page: 1,
        total: 0,
        totalPage: 10,
        searh: '',
      },
      page: 1,
      row: [],
      page: 1,
      per_page: 20,
    };
  },
  watch: {
    // filter() {
    //   this.pagination.search = this.filter
    //   this.page = 1
    //   this.pagination.page = 1
    //   this.procesando = true
    //   this.getClientes()
    // },
  },
  created() {
    this.getClientes();
  },
  mounted() {},
  methods: {
    onCancel() {},
    handleMenuClick() {},
    limpiarFiltros() {
      this.filter = '';
      this.sendRequestClientes();
    },
    onKeyPress() {
      // this.sendRequestClientes();
    },
    sendRequestClientes() {
      this.pagination.search = this.filter;
      this.page = 1;
      this.pagination.page = 1;
      this.procesando = true;
      this.getClientes();
    },
    onChange(page) {
      this.page = page;
      this.pagination.page = page;
      this.procesando = true;
      this.getClientes();
    },
    eliminar(clienteId) {
      let data = {
        clienteId: clienteId,
      };
      ServiceApi.post('/cliente/delete', data)
        .then(response => {
          //console.log('RESPUESTA:::', response)
          this.getClientes();
        })
        .catch(err => {
          this.$noty.error('Ocurrio un error al eliminar el cliente');
        });
    },
    getClientes() {
      let data = {
        filter: this.pagination,
        orden: {
          entidad: this.currentSort,
          tipo: this.currentSortOrder,
        },
      };
      ServiceApi.post(`/cliente/list`, data)
        .then(response => {
          // console.log('RESPUESTA:::', response);
          let data = response.data.Clientes;
          let paginacion = response.data.paginacion;
          this.row = data;
          this.pagination.totalPage = paginacion.lastPage * 10;
          this.pagination.total = paginacion.total;
          this.pagination.page = paginacion.page;
          // if(!data.data.length)this.$noty.warning('No se encontraron clientes creados')
          this.procesando = false;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.$noty.error(
            'Ocurrio un error al consultar los usuarios'
          );
          this.loading = false;
          this.$router.push('/');
        });
    },
    customSort(value) {
      if (
        this.currentSort === 'id' ||
        this.currentSort === 'telefono' ||
        this.currentSort === 'celular'
      ) {
        this.getClientes();
      } else {
        return value.sort((a, b) => {
          const sortBy = this.currentSort;
          if (this.currentSortOrder === 'desc') {
            return a[sortBy].localeCompare(b[sortBy]);
          }

          return b[sortBy].localeCompare(a[sortBy]);
        });
      }
    },
  },
};
</script>
